module.exports = __webpack_public_path__ + "img/max_speed.03b18479.svg";